// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__12OqW","list":"styles_list__2docf"};